import { Component, ElementRef, EventEmitter, Output, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, AuthService, MessageService, ButtonLoader } from '../../../../../core';
import { Pedido } from '../../../pedido';
import { PedidoIsLiberadoRequest, PedidoIsLiberadoResponse, PedidoLiberarRequest } from '../../adapters';
import { PedidoNaoLiberadoHttpService, PedidoLiberarCalculoService } from '../../services';
import { PedidoValidacoesHttpService } from '../../../validacao';
import { PedidoCrudHttpService } from '../../../services/pedido-crud-http.service';
import { isPedidoMotivoNaoLiberadoValid } from '../../domain';
import { Pessoa, PessoaCrudHttpService} from '../../../../pessoa';

interface Config {
    possuiMotivoNaoLiberado: boolean;
}

@Component({
    selector: 'sgt-pedido-liberar-modal',
    templateUrl: './pedido-liberar-modal.component.html',
    styleUrls: ['./pedido-liberar-modal.component.less']
})
export class PedidoLiberarModalComponent implements OnInit {
    config: Config;
    isRepresentante: boolean;

    /** Dados para realizar a liberação dos pedidos não liberados */
    req = new PedidoLiberarRequest();
    elModal: any;
    @Output() afterLiberar = new EventEmitter<Pedido>(); // Evento emitido após o liberar do pedido

    // Pedido
    isLoadingPedido: boolean;
    pedido: Pedido;
    percBonificacaoExcedente: number;

    pessoa: Pessoa;

    @ViewChild('form') form: NgForm;

    constructor(private el: ElementRef,
                private authService: AuthService,
                private messageService: MessageService,
                private pedidoCrudHttpService: PedidoCrudHttpService,
                private pedidoNaoLiberadoHttpService: PedidoNaoLiberadoHttpService,
                private pedidoLiberarCalculoService: PedidoLiberarCalculoService,
                private pedidoValidacoesHttpService: PedidoValidacoesHttpService,
                private pessoaCrudHttpService: PessoaCrudHttpService) { }

    ngOnInit() {
        this.isRepresentante = this.authService.isRepresentante();

        this.create();
    }

    private createConfig() {
        this.config = {
            possuiMotivoNaoLiberado: isPedidoMotivoNaoLiberadoValid(this.pedido?.motivoNaoLiberado)
        };
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                // jQuery(this.elModal).find('#justificativaLiberado').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open(idPedido: number) {
        this.clear();
        this.req = new PedidoLiberarRequest(idPedido);

        this.loadPedido(idPedido);

        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Verifica se o lucro líquido atual está permitido, ou seja, se o perc. do lucro líquido for maior ou igual ao perc. mínimo permitido  */
    isLucroLiquidoPermitido(): boolean {
        return this.pedido?.drp?.percLucroLiquido >= this.pedido?.drp?.percLucroLiquidoMinimo;
    }

    private clear() {
        this.form.resetForm();
        // Pedido
        this.pedido = null;
        this.percBonificacaoExcedente = null;
    }

    /** Carrega o pedido para obter os detalhes da não liberação do mesmo */
    private loadPedido(idPedido: number) {
        this.isLoadingPedido = true;
        this.pedidoCrudHttpService.load(idPedido)
            .subscribe(
                entity => {
                    this.pedido = entity;
                    this.percBonificacaoExcedente = this.pedidoLiberarCalculoService.calcularPercExcedenteBonificacao(this.pedido.percBonificacaoNaoLiberado, this.pedido.percBonificacaoMaximaNaoLiberado);

                    // Carregando a pessoa do cliente
                    this.loadPessoa(this.pedido?.idPessoa);

                    this.isLoadingPedido = false;
                    this.createConfig();
                },
                () => this.isLoadingPedido = false
            );
    }

    private loadPessoa(idPessoa: number) {
        this.pessoaCrudHttpService.load(idPessoa)
            .subscribe(
                pessoa => {
                    this.pessoa = pessoa;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar o cliente do pedido', error);
                }
            );
    }

    /** Realizando a liberação do pedido */
    liberar() {
        const btnLiberar = new ButtonLoader('#btnLiberar')
        btnLiberar.loading('Liberando');

        if (this.form.valid) {
            this.pedidoNaoLiberadoHttpService.liberar(this.req)
                .subscribe(
                    response => {
                        this.messageService.success('', `Pedido ${this.pedido?.numero} liberado com sucesso`);
                        btnLiberar.reset();
                        this.close();
                        this.afterLiberar.emit(this.pedido);
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao liberar o pedido', error);
                        btnLiberar.reset();
                    }
                );
        }
    }
}
